import { LogLevel, PublicClientApplication } from "@azure/msal-browser";
export const msalConfig = {
  auth: {
    clientId: process.env.VUE_APP_AD_CLIENT_ID,
    authority:
      "https://login.microsoftonline.com/80b51c29-f5b6-452f-94e9-23c16758bdb0", // This is a URL (e.g. https://login.microsoftonline.com/{your tenant ID})
    redirectUri: process.env.VUE_APP_ROOT_URI,
  },
  cache: {
    cacheLocation: "sessionStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
};

// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const loginRequest = {
  scopes: ["User.Read"],
};

// Add the endpoints here for Microsoft Graph API services you'd like to use.
export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
};

export const msalInstance = new PublicClientApplication(msalConfig);
